export default "https://cdn-static.gokick.com/assets/6909edbc169b94fbe838446b12805066cb856688/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";